import { useState } from "react";
import { Nav } from "react-bootstrap";
import { FiUsers } from "react-icons/fi";
import { FcInvite } from "react-icons/fc";
import { BsBuildings, BsGlobe } from "react-icons/bs";
import { MdAccountTree } from "react-icons/md";
import SetupAnothetAccount from "./ManageAnotherAccount/SetupAnothetAccount";
import InvitationManagement from "./InvitationManagement/InvitationManagement";
import ManageOtherProperty from "./ManageOtherProperty/ManageOtherProperty";
import { IoIosDesktop } from "react-icons/io";
import FileManagement from "./FileManagement/FileManagement";
import UserManagement from "./UserManagement/UserManagement";

const Accessibility = ({ organizationList, getOrganizations, currentUserData, getCurrectLoginUser }) => {
  const [openModule, setOpenModule] = useState("setupAccount");
  const menuItems = [
    { key: "setupAccount", label: "Manage Another Account", icon: <MdAccountTree /> },
    
    ...(currentUserData?.roleType === "organization"
      ? [
        { key: "manageProperty", label: "Manage Other Property", icon: <BsGlobe /> },
        { key: "userManagement", label: "User Management", icon: <FiUsers /> },
      ]
      : []),
    ...(!currentUserData?.loginAccountId
      ? [
        { key: "manageProperty", label: "Manage Other Property", icon: <BsGlobe /> },
      ]
      : []),
    { key: "invitationManagement", label: "Invitation Management", icon: <FcInvite /> },
    { key: "fileManager", label: "File Manager", icon: <IoIosDesktop /> },
  ];

  return (
    <div className="w-100 hstack">
      <div
        style={{ height: "calc(100vh - 56px)", minWidth: 250 }}
        className="overflow-auto border-end"
      >
        <div className="p-3 pb-0">
          <h6>Accessibility</h6>
        </div>
        <Nav className="flex-column p-2 gap-1">
          {menuItems.map((item) => {
            const isActive = openModule === item.key;
            return (
              <Nav.Link
                key={item.key}
                title={item.label}
                onClick={() => {
                  setOpenModule(item.key);
                }}
                className={`sidebar-link ${isActive ? "active" : ""}`}
              >
                <span className="icon" style={{ fontSize: 14 }}>
                  {item.icon}
                </span>
                <span className="label" style={{ fontSize: 14 }}>
                  {item.label}
                </span>
              </Nav.Link>
            );
          })}
        </Nav>
      </div>
      <div className="w-100 bg-light overflow-auto" style={{ height: "calc(100vh - 56px)" }}>
        {openModule === "setupAccount" && <SetupAnothetAccount organizationList={organizationList} currentUserData={currentUserData} getCurrectLoginUser={getCurrectLoginUser} />}
        {openModule === "manageProperty" && <ManageOtherProperty organizationList={organizationList} currentUserData={currentUserData} />}
        {openModule === "userManagement" && <UserManagement organizationList={organizationList} />}
        {openModule === "invitationManagement" && <InvitationManagement getOrganizations={getOrganizations} organizationList={organizationList} currentUserData={currentUserData} />}
        {openModule === "fileManager" && <FileManagement currentUserData={currentUserData} />}
      </div>
    </div>
  );
};

export default Accessibility;
